module.exports = __webpack_public_path__ + "static/media/hab9-1.ed9cf79e.jpg";